import type { Course } from "@/core/types";
import { modulAnsichtMakros } from "./ansicht-makros";
import { modulBedingteFormatierung } from "./bedingte-formatierung";
import { modulDatenAufbereiten } from "./daten-aufbereiten";
import { modulEffizienz } from "./effizienz";
import { modulDateneingabe } from "./dateneingabe";
import { modulDatenueberpruefung } from "./datenueberpruefung";
import { modulFormeln } from "./formeln";
import { modulDiagramme } from "./diagramme";
import { modulDrucken } from "./drucken";
import { modulFormatvorlagen } from "./formatvorlagen";
import { modulFunktionen } from "./funktionen";
import { modulFunktionenAufbau } from "./funktionen-aufbau";
import { modulGrundlagen } from "./grundlagen";
import { modulNamen } from "./namen";
import { modulPivot } from "./pivot";
import { modulSortieren } from "./sortieren";
import { modulTabellen } from "./tabellen";
import { modulWasWaereWenn } from "./was-waere-wenn";

/**
 * Excel-Komplettkurs.
 *
 * Eigenständiger Kurs neben dem Word- und dem PowerPoint-Kurs, kein Modul
 * davon: Excel hat ein eigenes Datenmodell – Blätter, Bereiche und Zellen
 * statt Absätzen oder Folien – und deshalb eine eigene Zugriffsschicht unter
 * src/office/excel/.
 *
 * Zwei Gedanken ziehen sich durch alle Module und prägen die Prüfungen:
 *
 * 1. Tabelle statt Zellhaufen. „Als Tabelle formatieren“ (Strg + T) macht aus
 *    einem losen Zellbereich ein Objekt mit Namen, Kopfzeile, automatischer
 *    Erweiterung und strukturierten Verweisen. Das ist die Entsprechung zu
 *    „Formatvorlagen statt direkter Formatierung“ im Word-Kurs und über
 *    Worksheet.tables samt Table.showHeaders und Table.name prüfbar.
 * 2. Excel rechnet – du tippst nicht. Ein Wert ist eine Zahl oder ein Datum,
 *    kein Text mit angehängter Einheit; eine Formel enthält Bezüge, keine
 *    getippten Konstanten. Prüfbar über Range.valueTypes, Range.numberFormat
 *    und eine Formelanalyse, die Zahlenliterale in Formeln findet.
 */
export const excelKurs: Course = {
  id: "excel-grundlagen",
  host: "Excel",
  title: "Excel Komplettkurs",
  summary:
    "Microsoft Excel von Grund auf: von der ersten Zelle bis zu Tabellen, Formeln, " +
    "PivotTables, Power Query, Was-wäre-wenn-Analysen und Makros – Auswertungen, die " +
    "auch dann noch stimmen, wenn neue Daten dazukommen.",
  level: "Komplettkurs",
  modules: [
    modulGrundlagen,
    modulDateneingabe,
    modulFormeln,
    modulFunktionen,
    modulTabellen,
    modulFormatvorlagen,
    modulEffizienz,
    modulSortieren,
    modulDiagramme,
    modulFunktionenAufbau,
    modulBedingteFormatierung,
    modulDatenueberpruefung,
    modulDatenAufbereiten,
    modulPivot,
    modulWasWaereWenn,
    modulNamen,
    modulAnsichtMakros,
    modulDrucken,
  ],
};
